import { InfinityScroll } from './shared/infinityscroll';
import Scroller from './shared/scroller';
import nativeAd from './shared/native';
import analytics from './shared/analytics';
import ImgLazyLoad from './shared/imglazyload';
import menuLogic from './shared/menuLogic/no-paid';
import { shouldRerenderSrcsetImages } from './shared/lib/polyfills';
import { stickyBanner } from './shared/stickyBanner';
import { initiateMemberOffersListeners } from './sites/elle/memberOffers';
import { initiateFavoriteArticles, initFavoriteButton, initFavoriteButtonSticky } from './sites/elle/favoriteArticles';
import '../../../public/common/SwipeHelper';
import memberMenuLogic from './sites/elle/memberMenuItems';
import memberCta from './sites/elle/memberCta';
import video from './shared/video';
import { videoRootMargin } from './shared/video/constants';

// Holder for lazyload functions.
window.lazyload = {};

// Page Scroller
window.scroller = new Scroller();

// Infinity Scroll
window.infinityscroll = new InfinityScroll({
  scroller: window.scroller,
});

if (!window.isEditMode) {
  window.imglazyload = new ImgLazyLoad();
}

analytics.init();

menuLogic.init();

const nativeImpressions = (content) => {
  const natives = content.querySelectorAll('article[data-type="native"]');

  if (natives) {
    natives.forEach((element) => {
      const link = element.querySelector('a.c-post__link:first-child');

      let url = '';

      if (link) {
        url = link.getAttribute('href') || '';
      }

      if (url) {
        const parts = url.match(/.*\/([^/]+)\/[^/]+/);

        let post = '';
        if (parts[1] !== null && parts[1] !== undefined) {
          post = parts[1];
        }

        if (url && post) {
          const dataLayerEvent = {
            event: 'nativearticlepuff',
            native_post: post,
            native_url: url,
          };

          dataLayer.push(dataLayerEvent);
        }
      }
    });
  }
};

// Lazyload function for affiliate gallery.
window.lazyload.affiliateGalleries = () => {
  const galleries = document.querySelectorAll('.ag-products:not(.initialized)');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          import(
            /* webpackChunkName: "affiliateGallery" */ './shared/affiliategallery/affiliateGallery'
          ).then((module) => {
            module.loadAffiliateGalleries();
          });
          observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: '300px',
    }
  );

  galleries.forEach((gallery) => {
    observer.observe(gallery);
  });
};

// Lazyload function for video.
window.lazyload.videos = (content) => {
  const videos = content.querySelectorAll('.jwplayer_video, .yp');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          video.initialize({ content: entry.target.parentElement });
          observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: videoRootMargin,
    }
  );

  videos.forEach((media) => {
    observer.observe(media);
  });
};

// Lazyload function for blog sliders.
window.lazyload.blogSliders = () => {
  const sliders = document.querySelectorAll('.blog-slider:not(.initialized)');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          import(/* webpackChunkName: "blogSlider" */ './shared/blogslider/blogSlider').then((module) => {
            module.loadBlogSliders();
          });
          observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: '300px',
    }
  );

  sliders.forEach((slider) => {
    observer.observe(slider);
  });
};

// Lazyload function for search.
window.lazyload.googleCustomSearch = () => {
  const url = window.location.href;

  if (url.includes('/search/?s=') || url.includes('/vara-skribenter/')) {
    const cseId = window.googleCustomSearch.id;
    const placeholderImage = window.googleCustomSearch.placeholderImage;


    import(
      /* webpackChunkName: "googleCustomSearch" */ './shared/googlecustomsearch/GoogleCustomSearch'
    ).then((module) => {
      if (!(window.googlecustomsearch instanceof module.default)) {
        window.googlecustomsearch = new module.default(cseId, placeholderImage, {
          hideUrl: true,
          showResultCount: true,
          hideSnippet: true,
        });
      }
    });
  }
};

// Lazyload function for editorsPick slideshows.
window.lazyload.editorsPickSlideshows = (isEditMode = false) => {
  const sliders = document.querySelectorAll('.editorsPick-slideshow:not(.initialized)');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          import(/* webpackChunkName: "editorsPickSlideshow" */ './shared/editorsPickSlideshow').then(
            (module) => {
              module.initEditorsPickSlideshows(isEditMode);
            }
          );
          observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: '300px',
    }
  );

  sliders.forEach((slider) => {
    observer.observe(slider);
  });
};

// Lazyload function for slideshows.
window.lazyload.slideshows = (isEditMode = false) => {
  const sliders = document.querySelectorAll('.slideshow:not(.initialized)');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio > 0) {
          import(/* webpackChunkName: "slideshow" */ './shared/slideshow').then((module) => {
            module.initSlideshows(isEditMode);
          });
          observer.unobserve(entry.target);
        }
      });
    },
    {
      rootMargin: '300px',
    }
  );

  sliders.forEach((slider) => {
    observer.observe(slider);
  });
};

document.addEventListener('DOMContentLoaded', function () {
  // NOTE: if you don't want something to run in edit mode, use window.isEditMode boolean

  // Fix for srcset images loaded with infinity scroll on Safari.
  shouldRerenderSrcsetImages();

  if (!window.isEditMode) {
    const element = document.querySelector('.c-menu__search form');
    if (element) {
      element.action = '/search/';
    }
  }

  // Maybe load search logic
  window.lazyload.googleCustomSearch();

  // Maybe load blogsliders
  window.lazyload.blogSliders();

  menuLogic.initMenuScrollHelper();

  // Native Impressions
  nativeImpressions(document);
  window.infinityscroll.on('new-content-loaded', (content) => {
    nativeImpressions(content);
  });

  // Native Ads
  nativeAd.init(document.querySelector('#content'));

  // Affiliate Gallery
  window.lazyload.affiliateGalleries();
  window.infinityscroll.on('new-content-loaded', () => {
    window.lazyload.affiliateGalleries();
  });

  // EditorsPickSlideshow
  window.lazyload.editorsPickSlideshows();
  window.infinityscroll.on('new-content-loaded', () => {
    window.lazyload.editorsPickSlideshows();
  });

  // Slideshows
  window.lazyload.slideshows();
  window.infinityscroll.on('new-content-loaded', () => {
    window.lazyload.slideshows();
  });

  //Load videos
  window.lazyload.videos(document);
  //Subscribe to infinity scroll events for videos
  window.infinityscroll.on('new-content-loaded', (ctx) => {
    window.lazyload.videos(document);
    if (window.video && window.video.youplay) {
      window.video.onNewContentLoaded(ctx);
      window.video.youplay.initializeYPPlayers(ctx);
    }
  });

  // Native Ads reload
  window.infinityscroll.on('new-content-loaded', (content) => {
    if (content instanceof HTMLElement) {
      nativeAd.init(content);
    }
  });

  // Instagram posts reload
  window.infinityscroll.on('new-content-loaded', () => window.instgrm && window.instgrm.Embeds.process());

  // Facebook comment reload
  window.infinityscroll.on('new-content-loaded', () => window.FB && FB.XFBML.parse());

  // Affiliate and native banner
  stickyBanner();
  window.infinityscroll.on('new-content-loaded', stickyBanner);

  // Pinterest pins build
  window.infinityscroll.on('new-content-loaded', () => window.parsePinBtns());

  // Member functionality
  // eslint-disable-next-line no-unused-expressions
  import('./sites/elle/authorization');

  // Run logic for member items in menu
  memberMenuLogic.init();

  // Remove prenumerera button on member my pages
  if (window.location.pathname.startsWith('/mina-sidor')) {
    document.querySelector("[href*='prenumerera.se']").style.display = 'none';
  }

  // Run logic for cta btns on elle.se/member
  if (window.location.pathname === '/member/') {
    memberCta.init();
  }

  initiateMemberOffersListeners();
  initFavoriteButton();
  initFavoriteButtonSticky();
  if (!window.isEditMode) {
    window.infinityscroll.on('new-content-loaded', () => {
      initFavoriteButton();
      initFavoriteButtonSticky();
    });
    document.addEventListener('loggedIn', function () {
      initiateFavoriteArticles();
    });
  }
});
